import React from 'react';
import { Check } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
export function HeroSection() {
  const bullets = ['Dejar de despertarte a las 3 de la mañana sudando', 'Volver a dormir 5-6 horas seguidas', 'Reducir la barriga sin hacer dietas extremas', 'Tener energía durante el día (sin neblina mental)'];
  return <section className="relative pt-10 pb-16 md:pt-20 md:pb-24 overflow-hidden bg-cream" data-id="element-94">
      {/* Background decorative elements for depth */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-95">
        <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] rounded-full bg-terracotta/5 blur-[120px]" data-id="element-96" />
        <div className="absolute top-[40%] -left-[20%] w-[60%] h-[60%] rounded-full bg-gold/10 blur-[100px]" data-id="element-97" />
      </div>

      <div className="container mx-auto px-5 relative z-10 max-w-5xl" data-id="element-98">
        <div className="flex flex-col items-center text-center" data-id="element-99">
          <FadeIn data-id="element-100">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white shadow-warm-sm border border-terracotta/10 mb-5" data-id="element-101">
              <span className="w-2 h-2 rounded-full bg-terracotta animate-pulse" data-id="element-102" />
              <span className="text-xs font-medium text-terracotta-dark tracking-wide uppercase" data-id="element-103">
                Para mujeres de 45+ años
              </span>
            </div>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-104">
            <h1 className="text-[1.65rem] leading-[1.2] md:text-5xl lg:text-6xl font-serif font-bold text-charcoal md:leading-tight mb-3 md:mb-5 text-balance" data-id="element-105">
              Empieza a dormir 5-6 horas seguidas en 7 días y reduce la barriga{' '}
              <span className="text-terracotta italic font-normal" data-id="element-106">
                (aunque hoy te despiertes a las 3am)
              </span>
            </h1>
          </FadeIn>

          <FadeIn delay={0.15} data-id="element-107">
            <p className="text-base md:text-xl text-charcoal-light max-w-3xl mx-auto mb-5 md:mb-8 leading-relaxed" data-id="element-108">
              Descubre el plan paso a paso que ya están usando mujeres de 45+
              para volver a dormir profundo, reducir la inflamación abdominal y
              recuperar energía{' '}
              <strong className="font-semibold text-charcoal" data-id="element-109">
                sin dietas ni pastillas.
              </strong>
            </p>
          </FadeIn>

          {/* CTA FIRST — visible without scrolling */}
          <FadeIn delay={0.2} data-id="element-110">
            <CTAButton data-id="element-111" />
            <p className="mt-3 text-xs md:text-sm text-charcoal-muted font-medium" data-id="element-112">
              Acceso inmediato · Basado en ciencia · Diseñado para la menopausia
            </p>
          </FadeIn>

          {/* Bullets BELOW the CTA as supporting proof */}
          <FadeIn delay={0.3} className="w-full max-w-2xl mx-auto mt-10 md:mt-14" data-id="element-113">
            <div className="bg-white rounded-2xl p-5 md:p-8 shadow-card border border-cream-dark/50 text-left" data-id="element-114">
              <ul className="space-y-3 md:space-y-4" data-id="element-115">
                {bullets.map((bullet, index) => <li key={index} className="flex items-start gap-3" data-id="element-116">
                    <div className="flex-shrink-0 w-5 h-5 md:w-6 md:h-6 rounded-full bg-terracotta/10 flex items-center justify-center mt-0.5" data-id="element-117">
                      <Check className="w-3 h-3 md:w-4 md:h-4 text-terracotta" strokeWidth={3} data-id="element-118" />
                    </div>
                    <span className="text-charcoal-light font-medium text-sm md:text-lg" data-id="element-119">
                      {bullet}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}